// References:
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// https://gist.github.com/1579671
// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
// https://gist.github.com/timhall/4078614
// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
// Expected to be used with Browserfiy
// Browserify automatically detects the use of `global` and passes the
// correct reference of `global`, `self`, and finally `window`
const ONE_FRAME_TIME = 16; // Date.now

if (!(Date.now && Date.prototype.getTime)) {
  Date.now = function now() {
    return new Date().getTime();
  };
} // performance.now


if (!(window.performance && window.performance.now)) {
  const startTime = Date.now();

  if (!window.performance) {
    window.performance = {};
  }

  window.performance.now = () => Date.now() - startTime;
} // requestAnimationFrame


let lastTime = Date.now();
const vendors = ['ms', 'moz', 'webkit', 'o'];

for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
  const p = vendors[x];
  window.requestAnimationFrame = window[`${p}RequestAnimationFrame`];
  window.cancelAnimationFrame = window[`${p}CancelAnimationFrame`] || window[`${p}CancelRequestAnimationFrame`];
}

if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = callback => {
    if (typeof callback !== 'function') {
      throw new TypeError(`${callback}is not a function`);
    }

    const currentTime = Date.now();
    let delay = ONE_FRAME_TIME + lastTime - currentTime;

    if (delay < 0) {
      delay = 0;
    }

    lastTime = currentTime;
    return window.setTimeout(() => {
      lastTime = Date.now();
      callback(performance.now());
    }, delay);
  };
}

if (!window.cancelAnimationFrame) {
  window.cancelAnimationFrame = id => clearTimeout(id);
}

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var eventemitter3 = createCommonjsModule(function (module) {
  var has = Object.prototype.hasOwnProperty,
      prefix = '~';
  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @private
   */

  function Events() {} //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //


  if (Object.create) {
    Events.prototype = Object.create(null); //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //

    if (!new Events().__proto__) prefix = false;
  }
  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @private
   */


  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }
  /**
   * Add a listener for a given event.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} once Specify if the listener is a one-time listener.
   * @returns {EventEmitter}
   * @private
   */


  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') {
      throw new TypeError('The listener must be a function');
    }

    var listener = new EE(fn, context || emitter, once),
        evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  /**
   * Clear event by name.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} evt The Event name.
   * @private
   */


  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
  }
  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @public
   */


  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @public
   */


  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
        events,
        name;
    if (this._eventsCount === 0) return names;

    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };
  /**
   * Return the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Array} The registered listeners.
   * @public
   */


  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event,
        handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [handlers.fn];

    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }

    return ee;
  };
  /**
   * Return the number of listeners listening to a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Number} The number of listeners.
   * @public
   */


  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event,
        listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
  };
  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @public
   */


  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt],
        len = arguments.length,
        args,
        i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;

        case 2:
          return listeners.fn.call(listeners.context, a1), true;

        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;

        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;

        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
          j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;

          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;

          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;

          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;

          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };
  /**
   * Add a listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };
  /**
   * Add a one-time listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };
  /**
   * Remove the listeners of a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {*} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;

    if (!fn) {
      clearEvent(this, evt);
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      } //
      // Reset the array, or remove it completely if we have no more listeners.
      //


      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
    }

    return this;
  };
  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {(String|Symbol)} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  }; //
  // Alias methods names because people roll like that.
  //


  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
  // Expose the prefix.
  //

  EventEmitter.prefixed = prefix; //
  // Allow `EventEmitter` to be imported as module namespace.
  //

  EventEmitter.EventEmitter = EventEmitter; //
  // Expose the module.
  //

  {
    module.exports = EventEmitter;
  }
});
/**
 * stringfy to a better message
 * @param value
 */

function stringfy(obj) {
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === 'function') return value.toString();

    if (typeof value === 'number') {
      if (isPlainNumber(value)) return value;
      return value.toString();
    }

    return value;
  }, '\t');
}
/**
 * extended Error
 */


class ParseError extends Error {
  constructor(from, to, _message = `"from" and "to" have different format`) {
    const message = `${_message}:
"from":  ${stringfy(from)},
"to"  : ${stringfy(to)},
`;
    super(message);
    this.name = 'Parse Error';
  }

} // a: tweening object
// b: status  0~1


function getEmptyType(from) {
  if (Array.isArray(from)) return '[]';
  if (typeof from === 'object') return '{}';
  return `throw new Error(\`"from" type error: ${stringfy(from)}\`)`;
}

function isPlainNumber(v) {
  // test is number and not is NaN
  return typeof v === 'number' && v === v;
}

function parse(from, _to, config) {
  const {
    isAssign = true
  } = config || {};
  let expression = '';
  const status = {
    config: config,
    count: 0
  };
  const to = typeof _to === 'function' ? _to(from, status.config) : _to;

  if (from !== to) {
    if (typeof to === 'object' && typeof from === 'object') {
      expression = (isAssign ? '' : `var a=${getEmptyType(from)};`) + baseParseFromTo(from, to, 'a', isAssign, status);
    } else if (isPlainNumber(to) && isPlainNumber(from)) {
      expression = `a=${from}+b*${to - from};`;
    } else throw new ParseError(from, to);
  }

  const func = new Function('a', 'b', expression + 'return a;');
  return function tween(status) {
    return func(from, status);
  };
}

function baseParseFromTo(from, to, expressionKey, isAssign, status) {
  let expression = '';

  for (const key in to) {
    const fromValue = from[key];
    const toValue = typeof to[key] === 'function' ? to[key](fromValue, status.config) : to[key];

    if (fromValue !== toValue) {
      if (typeof toValue === 'object' && typeof fromValue === 'object') {
        const newExpressionKey = `a${status.count++}`;
        expression += `var ${newExpressionKey}=${expressionKey}["${key}"]${isAssign ? '' : `=${getEmptyType(fromValue)}`};${baseParseFromTo(fromValue, toValue, newExpressionKey, isAssign, status)}`;
      } else if (isPlainNumber(toValue) && isPlainNumber(fromValue)) {
        expression += `${expressionKey}["${key}"]=${fromValue}+b*${toValue - fromValue};`;
      } else throw new ParseError(fromValue, toValue);
    }
  }

  return expression;
}

const transforms = {};
/**
 * register a transform
 * @param id - transform id
 * @param func
 */

function register(id, func) {
  if (id in transforms) throw new Error(`${id} exists`);
  transforms[id] = func;
}
/**
 * apply transfrom to AnimateInstance
 * @param ins
 * @param id
 * @param args
 */


function transform(ins, id, ...args) {
  const item = transforms[id];

  if (typeof item === 'function') {
    item(ins, ...args);
  } else throw new Error(`transform "${id}" don't exist`);
} // internal transforms


register('loop', (ins, count) => {
  const _fullTime = ins.fullTime;
  ins.fullTime *= count;
  const tween = ins.tween;

  ins.tween = (status, duration, fullTime) => {
    if (status >= 1) return tween(1, _fullTime, _fullTime);

    const _duration = duration % _fullTime;

    return tween(_duration / _fullTime, _duration, _fullTime);
  };
});
register('speed', (ins, speed) => {
  ins.fullTime /= speed;
});
register('reverse', ins => {
  const tween = ins.tween;

  ins.tween = (status, duration, fullTime) => {
    return tween(1 - status, duration, fullTime);
  };
});
register('yoyo', ins => {
  const _fullTime = ins.fullTime;
  ins.fullTime *= 2;
  const tween = ins.tween;

  ins.tween = (status, duration, fullTime) => {
    if (status <= 0.5) {
      return tween(2 * status, duration, _fullTime);
    } else {
      return tween(2 * (1 - status), fullTime - duration, _fullTime);
    }
  };
});
register('delay', (ins, time) => {
  const _fullTime = ins.fullTime;
  ins.fullTime += time;
  const tween = ins.tween;

  ins.tween = (status, duration, fullTime) => {
    if (duration > time) {
      const _duration = duration - time;

      return tween(_duration / _fullTime, _duration, _fullTime);
    }
  };
});
register('step', (ins, count) => {
  const tween = ins.tween;
  const stepTime = ins.fullTime / count;

  ins.tween = (status, duration, fullTime) => {
    const v = tween((status * count | 0) / count, duration, fullTime);
    ins.isPlaying = false;
    setTimeout(() => {
      ins.time += stepTime;
      ins.isPlaying = true;
    }, stepTime);
    return v;
  };
});

function createTweenFunction(from, to, options) {
  let middleware;

  if (options.parser) {
    const parser = options.parser;

    if ('parse' in parser && 'apply' in parser) {
      middleware = item => {
        const parsed = parse(parser.parse(item), to, options);
        const easing = options.easing;
        return status => {
          let v = parsed(easing(status));
          parser.apply(item, v);
          return v;
        };
      };
    } else throw new Error(`options "parser" should both have "parse" and "apply" methods`);
  } else {
    middleware = item => {
      const parsed = parse(item, to, options);
      const easing = options.easing;
      return status => parsed(easing(status));
    };
  }

  if (from.length === 1) {
    return middleware(from[0]);
  }

  const list = from.map(item => middleware(item));
  const easing = options.easing;
  return function tween(status) {
    const n = easing(status);
    return list.map(t => t(n));
  };
}
/**
 * use delay to listener "start" event,
 * Animate(1, 1000).apply(0).on('start', console.log);
 * if you don't use delay, it will emit "start" before you listen
 */


const delay = 'Promise' in window ? function () {
  const resolved = Promise.resolve();
  return function delay(func) {
    resolved.then(func);
  };
}() : function delay(func) {
  setTimeout(func);
};

class AnimateInstance extends eventemitter3 {
  constructor(animate, options, from) {
    super();
    this.isPlaying = true;
    this.isCompleted = false;
    this.time = 0;
    this.startTime = performance.now();
    const {
      to
    } = animate;
    if (!options.time) throw new Error('please give "time" option before apply');
    this.fullTime = options.time;
    this.tween = createTweenFunction(from, to, options);
    const emit = this.emit;

    this.emit = function (key, a) {
      emit.call(this, key, a);
      animate.emit(key, a);
    };

    options.list.push(this); // add to update list

    delay(() => {
      this.emit('start');
    });
  }

  transform(key, ...args) {
    transform(this, key, ...args);
    return this;
  }

  stop() {
    this.isPlaying = false;
    this.stopTime = performance.now();
    this.emit('stop');
  }

  play() {
    const time = performance.now();

    if (this.stopTime) {
      const elpased = time - this.stopTime;
      this.time += elpased;
      this.startTime += elpased;
      this.stopTime = null;
    } else {
      throw new Error('play can be only called after stop is called');
    }

    this.isPlaying = true;
    this.emit('play');
  }

  update(now) {
    if (this.isPlaying) {
      const {
        fullTime,
        tween,
        startTime
      } = this;
      this.time = now - startTime;
      const status = this.time / fullTime;

      if (status >= 1) {
        const v = tween(1, fullTime, fullTime);
        if (v !== undefined) this.emit('update', v);
        this.complete();
      } else {
        const v = tween(status, this.time, fullTime);
        if (v !== undefined) this.emit('update', v);
      }
    }
  }

  updateElpased(elpased) {
    if (this.isPlaying) {
      const {
        fullTime,
        tween
      } = this;
      this.time += elpased;
      const status = this.time / fullTime;

      if (status >= 1) {
        const v = tween(1, fullTime, fullTime);
        if (v !== undefined) this.emit('update', v);
        this.complete();
      } else {
        const v = tween(status, this.time, fullTime);
        if (v !== undefined) this.emit('update', v);
      }
    }
  }

  complete() {
    this.isCompleted = true;
    this.emit('complete');
    this.destroy();
  }

  destroy() {
    this.isPlaying = false;
    this.emit = null;
    this.removeAllListeners();
    this.tween = null;
  }

}

function cloneEventEmitter(from, to) {
  const {
    _events,
    _eventsCount
  } = from;
  if (_eventsCount === 0) return;
  const toEvents = to._events;

  for (const key in _events) {
    const item = _events[key];

    if (Array.isArray(item)) {
      toEvents[key] = [...item];
    } else toEvents[key] = item;
  }

  to._eventsCount = _eventsCount;
}
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */


const Easing = {
  Linear: {
    None: function (amount) {
      return amount;
    }
  },
  Quadratic: {
    In: function (amount) {
      return amount * amount;
    },
    Out: function (amount) {
      return amount * (2 - amount);
    },
    InOut: function (amount) {
      if ((amount *= 2) < 1) {
        return 0.5 * amount * amount;
      }

      return -0.5 * (--amount * (amount - 2) - 1);
    }
  },
  Cubic: {
    In: function (amount) {
      return amount * amount * amount;
    },
    Out: function (amount) {
      return --amount * amount * amount + 1;
    },
    InOut: function (amount) {
      if ((amount *= 2) < 1) {
        return 0.5 * amount * amount * amount;
      }

      return 0.5 * ((amount -= 2) * amount * amount + 2);
    }
  },
  Quartic: {
    In: function (amount) {
      return amount * amount * amount * amount;
    },
    Out: function (amount) {
      return 1 - --amount * amount * amount * amount;
    },
    InOut: function (amount) {
      if ((amount *= 2) < 1) {
        return 0.5 * amount * amount * amount * amount;
      }

      return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
    }
  },
  Quintic: {
    In: function (amount) {
      return amount * amount * amount * amount * amount;
    },
    Out: function (amount) {
      return --amount * amount * amount * amount * amount + 1;
    },
    InOut: function (amount) {
      if ((amount *= 2) < 1) {
        return 0.5 * amount * amount * amount * amount * amount;
      }

      return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
    }
  },
  Sinusoidal: {
    In: function (amount) {
      return 1 - Math.cos(amount * Math.PI / 2);
    },
    Out: function (amount) {
      return Math.sin(amount * Math.PI / 2);
    },
    InOut: function (amount) {
      return 0.5 * (1 - Math.cos(Math.PI * amount));
    }
  },
  Exponential: {
    In: function (amount) {
      return amount === 0 ? 0 : Math.pow(1024, amount - 1);
    },
    Out: function (amount) {
      return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
    },
    InOut: function (amount) {
      if (amount === 0) {
        return 0;
      }

      if (amount === 1) {
        return 1;
      }

      if ((amount *= 2) < 1) {
        return 0.5 * Math.pow(1024, amount - 1);
      }

      return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
    }
  },
  Circular: {
    In: function (amount) {
      return 1 - Math.sqrt(1 - amount * amount);
    },
    Out: function (amount) {
      return Math.sqrt(1 - --amount * amount);
    },
    InOut: function (amount) {
      if ((amount *= 2) < 1) {
        return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
      }

      return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
    }
  },
  Elastic: {
    In: function (amount) {
      if (amount === 0) {
        return 0;
      }

      if (amount === 1) {
        return 1;
      }

      return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
    },
    Out: function (amount) {
      if (amount === 0) {
        return 0;
      }

      if (amount === 1) {
        return 1;
      }

      return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
    },
    InOut: function (amount) {
      if (amount === 0) {
        return 0;
      }

      if (amount === 1) {
        return 1;
      }

      amount *= 2;

      if (amount < 1) {
        return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
      }

      return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
    }
  },
  Back: {
    In: function (amount) {
      const s = 1.70158;
      return amount * amount * ((s + 1) * amount - s);
    },
    Out: function (amount) {
      const s = 1.70158;
      return --amount * amount * ((s + 1) * amount + s) + 1;
    },
    InOut: function (amount) {
      const s = 1.70158 * 1.525;

      if ((amount *= 2) < 1) {
        return 0.5 * (amount * amount * ((s + 1) * amount - s));
      }

      return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
    }
  },
  Bounce: {
    In: function (amount) {
      return 1 - Easing.Bounce.Out(1 - amount);
    },
    Out: function (amount) {
      if (amount < 1 / 2.75) {
        return 7.5625 * amount * amount;
      } else if (amount < 2 / 2.75) {
        return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
      } else if (amount < 2.5 / 2.75) {
        return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
      } else {
        return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
      }
    },
    InOut: function (amount) {
      if (amount < 0.5) {
        return Easing.Bounce.In(amount * 2) * 0.5;
      }

      return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
    }
  }
};
/**
 * filter with modify array
 * @param {array} arr
 * @param {function} func
 */

function filterWithModifyArray(arr, func) {
  let keep = false;
  let start = 0;
  let deleteCount = 0;
  const len = arr.length;

  for (let i = 0; i < len - deleteCount; i++) {
    if (func(arr[i], deleteCount + i)) {
      if (keep) {
        keep = !keep;
        arr.splice(start, i - start);
        deleteCount += i - start;
        i = start;
      }
    } else if (!keep) {
      start = i;
      keep = !keep;
    }
  }

  if (keep) {
    arr.splice(start, arr.length - start);
  }
}
/**
 * global update list
 */


const GLOBAL_LIST = [];
/**
 * call this function in your custom requestAnimationFrame
 * ```js
 * const { update }  = Animate;
 * function animate(time) {
 *   requestAnimationFrame(animate)
 *   update();
 * }
 * requestAnimationFrame(animate)
 * ```
 * @param list - update list , default to global list
 */

function update(list = GLOBAL_LIST) {
  if (list.length === 0) return;
  const now = performance.now();
  filterWithModifyArray(list, ins => {
    if (ins.isCompleted) {
      return false;
    }

    ins.update(now);
    return true;
  });
}
/**
 * behaves like update, can pass elpased time, like `updateElpased(1000)` to update 1000ms;
 * @param elpased elpased time
 * @param list update list
 */


function updateElapsed(elpased, list = GLOBAL_LIST) {
  if (list.length === 0) return;
  filterWithModifyArray(list, ins => {
    if (ins.isCompleted) {
      return false;
    }

    ins.updateElpased(elpased);
    return true;
  });
}

const animationFrame = function () {
  const requestAnimationFrame = window.requestAnimationFrame;
  let playing = false;

  function ticker() {
    if (playing) {
      update();
      requestAnimationFrame(ticker);
    }
  }

  return {
    /**
     * play requestAnimationFrame.
     * if you want to use custom requestAnimaionFrame, use update function
     */
    play() {
      playing = true;
      requestAnimationFrame(ticker);
    },

    /**
     * stop requestAnimationFrame
     */
    stop() {
      playing = false;
    }

  };
}();

const OPTIONS = {
  time: 0,
  easing: Easing.Linear.None,
  isAssign: true,
  list: GLOBAL_LIST
};

function parseOptions(inputOptions, baseOptions) {
  if (!inputOptions) return OPTIONS;
  const options = baseOptions ? { ...baseOptions
  } : { ...OPTIONS
  };
  if (typeof inputOptions === 'number') options.time = inputOptions;else {
    Object.assign(options, inputOptions);
  }
  return options;
}

const WrapperAnimateAssignData = {
  hasCloneEventEmitter: false,
  on: function (...args) {
    if (!this.hasCloneEventEmitter) {
      this.animate = cloneAnimate(this.animate);
      this.hasCloneEventEmitter = true;
    }

    this.animate.on(...args);
    return this;
  },
  once: function (...args) {
    if (!this.hasCloneEventEmitter) {
      this.animate = cloneAnimate(this.animate);
      this.hasCloneEventEmitter = true;
    }

    this.animate.on(...args);
    return this;
  },
  off: function (...args) {
    if (!this.hasCloneEventEmitter) {
      this.animate = cloneAnimate(this.animate);
      this.hasCloneEventEmitter = true;
    }

    this.animate.on(...args);
    return this;
  }
}; // return wrapper

function createAnimateWrapper(animate, options) {
  const _function = function AnimateWrapper(_options) {
    return createAnimateWrapper(_function.animate, parseOptions(_options, options));
  };

  _function.animate = animate;
  _function.config = _function;
  Object.assign(_function, WrapperAnimateAssignData);

  _function.apply = function (...items) {
    const ins = new AnimateInstance(_function.animate, options, items);
    return ins;
  };

  _function.transform = function (key, ...args) {
    const wrapper = createAnimateWrapper(_function.animate, options);

    wrapper.apply = function (...items) {
      const baseIns = _function.apply(...items);

      const ins = baseIns.transform(key, ...args);
      return ins;
    };

    return wrapper;
  };

  return _function;
}

function cloneAnimate(animate) {
  const _animate = new eventemitter3();

  _animate.to = animate.to;
  cloneEventEmitter(animate, _animate);
  return _animate;
}

function AnimateFunction(fromOrTo, toOroptions, options) {
  if (arguments.length >= 3) {
    const animate = new eventemitter3();
    animate.to = toOroptions;
    return new AnimateInstance(animate, parseOptions(options), [fromOrTo]);
  }

  const animate = new eventemitter3();
  animate.to = fromOrTo;
  return createAnimateWrapper(animate, parseOptions(toOroptions));
}

const Animate = AnimateFunction;
Animate.play = animationFrame.play;
Animate.stop = animationFrame.stop;
Animate.registerTransform = register;
Animate.Easing = Easing;
Animate.update = update;
Animate.list = GLOBAL_LIST;
Animate.updateElpased = updateElapsed;
export default Animate;